<app-table [data]="filteredBackups"
           [config]="tableConfig"
           [rowExpand]="false"
           [hasTitle]="false"
           [filtersToggle]="false"
           [showFilters]="showFilters"
           [selectableRows]="true"
           [hasPagination]="hasPagination"
           [isLoading]="isLoading"
           [isMaterial]="false"
           (filterChange)="onFilterChange($event)">

    <app-table-column header="{{'admin.tools.details.detailsPage.toolBackups' | translate}}"
                      filterPlaceholder="{{'admin.tools.details.detailsPage.toolBackupsFilter' | translate}}"
                      [filter]="true"
                      field="name">
        <ng-template #body
                     let-tool="rowData">
            <div class="tool-select">
                <input *ngIf="selectableRows"
                       type="checkbox"
                       [checked]="isChecked(tool)"
                       (change)="checkTools(tool)"/>
                <span>{{this.buildBackupName(tool)}}</span>
            </div>
        </ng-template>
    </app-table-column>
</app-table>
